var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarWashColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4548 10.5142C18.1015 9.93635 17.4822 9.5918 16.8029 9.5918H7.6843C7.0061 9.5918 6.38571 9.93635 6.03241 10.5142L3.61292 14.4416C3.42647 14.748 3.32617 15.1002 3.32617 15.4578V20.8355C3.32617 21.4766 3.84736 21.9989 4.48958 21.9989H6.42822C7.06935 21.9989 7.59163 21.4777 7.59163 20.8355V20.4473H16.8956V20.8355C16.8956 21.4766 17.4168 21.9989 18.059 21.9989H19.9976C20.6387 21.9989 21.161 21.4777 21.161 20.8355V15.4578C21.161 15.1013 21.0607 14.748 20.8743 14.4416L18.4548 10.5142ZM19.6105 16.5688C19.6105 16.7825 19.4361 16.957 19.2224 16.957H18.059C17.6676 16.957 17.287 17.1162 17.0079 17.3909L16.9425 17.4564C16.6633 17.7399 16.5085 18.1117 16.5085 18.5075C16.5085 18.7212 16.334 18.8956 16.1203 18.8956C15.9066 18.8956 15.7322 18.7212 15.7322 18.5075C15.7322 17.9023 15.9688 17.3364 16.3951 16.9101L16.4605 16.8447C16.8792 16.4216 17.4648 16.1817 18.0579 16.1817H19.2213C19.435 16.1817 19.6095 16.3562 19.6095 16.5699L19.6105 16.5688ZM18.8342 13.856C18.8342 14.0697 18.6598 14.2442 18.4461 14.2442H16.1204C15.9067 14.2442 15.7322 14.0697 15.7322 13.856C15.7322 13.6423 15.9067 13.4679 16.1204 13.4679H18.4461C18.6598 13.4679 18.8342 13.6423 18.8342 13.856ZM15.3451 13.856C15.3451 14.0697 15.1707 14.2442 14.957 14.2442H6.04017C5.82646 14.2442 5.65202 14.0697 5.65202 13.856C5.65202 13.6423 5.82647 13.4679 6.04017 13.4679H14.957C15.1707 13.4679 15.3451 13.6423 15.3451 13.856ZM9.5303 18.1203C9.31659 18.1203 9.14214 17.9458 9.14214 17.7321C9.14214 17.5184 9.31659 17.344 9.5303 17.344H14.958C15.1717 17.344 15.3461 17.5184 15.3461 17.7321C15.3461 17.9458 15.1717 18.1203 14.958 18.1203H9.5303ZM13.4077 18.8955C13.4077 19.1092 13.2332 19.2837 13.0195 19.2837H11.469C11.2553 19.2837 11.0809 19.1092 11.0809 18.8955C11.0809 18.6818 11.2553 18.5074 11.469 18.5074H13.0195C13.2332 18.5074 13.4077 18.6818 13.4077 18.8955ZM8.75515 18.5074C8.75515 18.7211 8.5807 18.8955 8.367 18.8955C8.15329 18.8955 7.97884 18.7211 7.97884 18.5074C7.97884 18.1116 7.82401 17.7398 7.54488 17.4563L7.47946 17.3908C7.20033 17.1161 6.82088 16.9569 6.42837 16.9569H5.26496C5.05125 16.9569 4.8768 16.7824 4.8768 16.5687C4.8768 16.355 5.05126 16.1806 5.26496 16.1806H6.42837C7.02152 16.1806 7.60705 16.4204 8.02574 16.8435L8.09116 16.9089C8.51748 17.3352 8.75409 17.9011 8.75409 18.5063L8.75515 18.5074ZM6.81652 20.8342C6.81652 21.0479 6.64315 21.2223 6.42836 21.2223H4.48972C4.27602 21.2223 4.10157 21.0479 4.10157 20.8342V20.0589C4.42321 20.3032 4.82666 20.4471 5.26498 20.4471H6.81546V20.8352L6.81652 20.8342ZM20.3858 20.8342C20.3858 21.0479 20.2125 21.2223 19.9977 21.2223H18.059C17.8453 21.2223 17.6709 21.0479 17.6709 20.8342V20.446H19.2214C19.6597 20.446 20.0631 20.3021 20.3848 20.0578V20.8331L20.3858 20.8342Z",
    fill: "url(#paint0_linear_6264_73442)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4868 13.4681C23.4868 12.827 22.9656 12.3047 22.3234 12.3047H20.7729C20.5581 12.3047 20.3848 12.4781 20.3848 12.6928C20.3848 12.9066 20.5581 13.081 20.7729 13.081H22.3234C22.5371 13.081 22.7116 13.2555 22.7116 13.4692C22.7116 13.6829 22.5382 13.8573 22.3234 13.8573H21.9352C21.7204 13.8573 21.5471 14.0307 21.5471 14.2455C21.5471 14.4592 21.7205 14.6336 21.9352 14.6336H22.3234C22.9645 14.6336 23.4868 14.1124 23.4868 13.4702V13.4681Z",
    fill: "url(#paint1_linear_6264_73442)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55157 13.8563H2.16341C1.9497 13.8563 1.77525 13.6819 1.77525 13.4682C1.77525 13.2545 1.94862 13.08 2.16341 13.08H3.71389C3.92869 13.08 4.10205 12.9067 4.10205 12.6919C4.10205 12.4782 3.92868 12.3037 3.71389 12.3037H2.16341C1.52228 12.3037 1 12.8249 1 13.4671C1 14.1083 1.52119 14.6305 2.16341 14.6305H2.55157C2.76637 14.6305 2.93973 14.4572 2.93973 14.2424C2.93973 14.0287 2.76636 13.8542 2.55157 13.8542V13.8563Z",
    fill: "url(#paint2_linear_6264_73442)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3846 7.65117C20.3846 7.86488 20.559 8.03933 20.7727 8.03933C20.9864 8.03933 21.1609 7.86487 21.1609 7.65117C21.1609 6.79416 21.6843 6.10069 22.3243 6.10069C22.538 6.10069 22.7125 5.92624 22.7125 5.71254C22.7125 5.49883 22.538 5.32438 22.3243 5.32438C21.6843 5.32438 21.1609 4.63091 21.1609 3.7739C21.1609 3.56019 20.9864 3.38574 20.7727 3.38574C20.559 3.38574 20.3846 3.5602 20.3846 3.7739C20.3846 4.63091 19.8612 5.32438 19.2212 5.32438C19.0075 5.32438 18.833 5.49883 18.833 5.71254C18.833 5.92624 19.0075 6.10069 19.2212 6.10069C19.8612 6.10069 20.3846 6.79416 20.3846 7.65117Z",
    fill: "url(#paint3_linear_6264_73442)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93926 10.366C2.93926 10.5797 3.11372 10.7542 3.32742 10.7542C3.54112 10.7542 3.71558 10.5797 3.71558 10.366C3.71558 9.50901 4.23895 8.81554 4.87899 8.81554C5.0927 8.81554 5.26715 8.64108 5.26715 8.42738C5.26715 8.21367 5.09269 8.03922 4.87899 8.03922C4.23895 8.03922 3.71558 7.34575 3.71558 6.48874C3.71558 6.27504 3.54112 6.10059 3.32742 6.10059C3.11372 6.10059 2.93926 6.27504 2.93926 6.48874C2.93926 7.34575 2.4159 8.03922 1.77585 8.03922C1.56215 8.03922 1.3877 8.21368 1.3877 8.42738C1.3877 8.64109 1.56215 8.81554 1.77585 8.81554C2.4159 8.81554 2.93926 9.50901 2.93926 10.366Z",
    fill: "url(#paint4_linear_6264_73442)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97995 3C7.76516 3 7.5918 3.17336 7.5918 3.38816V3.77631C7.5918 3.99002 7.76516 4.16447 7.97995 4.16447C8.19475 4.16447 8.36811 3.99111 8.36811 3.77631V3.38816C8.36811 3.17445 8.19475 3 7.97995 3Z",
    fill: "url(#paint5_linear_6264_73442)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5918 5.71381C7.5918 5.92752 7.76516 6.10197 7.97995 6.10197C8.19475 6.10197 8.36811 5.92861 8.36811 5.71381V5.32566C8.36811 5.11195 8.19475 4.9375 7.97995 4.9375C7.76516 4.9375 7.5918 5.11087 7.5918 5.32566V5.71381Z",
    fill: "url(#paint6_linear_6264_73442)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75437 4.9394H9.14252C9.35732 4.9394 9.53068 4.76604 9.53068 4.55124C9.53068 4.33753 9.35732 4.16309 9.14252 4.16309H8.75437C8.53957 4.16309 8.36621 4.33645 8.36621 4.55124C8.36621 4.76495 8.53957 4.9394 8.75437 4.9394Z",
    fill: "url(#paint7_linear_6264_73442)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20503 4.16406H6.81687C6.60207 4.16406 6.42871 4.33743 6.42871 4.55222C6.42871 4.76593 6.60208 4.94038 6.81687 4.94038H7.20503C7.41982 4.94038 7.59318 4.76701 7.59318 4.55222C7.59318 4.33851 7.41982 4.16406 7.20503 4.16406Z",
    fill: "url(#paint8_linear_6264_73442)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3442 5.71387C15.1294 5.71387 14.9561 5.88723 14.9561 6.10202V6.49018C14.9561 6.70389 15.1294 6.87834 15.3442 6.87834C15.559 6.87834 15.7324 6.70497 15.7324 6.49018V6.10202C15.7324 5.88832 15.559 5.71387 15.3442 5.71387Z",
    fill: "url(#paint9_linear_6264_73442)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.958 8.42768C14.958 8.64139 15.1314 8.81584 15.3462 8.81584C15.561 8.81584 15.7343 8.64247 15.7343 8.42768V8.03953C15.7343 7.82582 15.561 7.65137 15.3462 7.65137C15.1314 7.65137 14.958 7.82473 14.958 8.03953V8.42768Z",
    fill: "url(#paint10_linear_6264_73442)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1216 7.65229H16.5097C16.7245 7.65229 16.8979 7.47893 16.8979 7.26413C16.8979 7.05043 16.7245 6.87598 16.5097 6.87598H16.1216C15.9068 6.87598 15.7334 7.04934 15.7334 7.26413C15.7334 7.47784 15.9068 7.65229 16.1216 7.65229Z",
    fill: "url(#paint11_linear_6264_73442)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5693 6.87793H14.1811C13.9663 6.87793 13.793 7.05129 13.793 7.26609C13.793 7.47979 13.9663 7.65424 14.1811 7.65424H14.5693C14.7841 7.65424 14.9574 7.48088 14.9574 7.26609C14.9574 7.05238 14.7841 6.87793 14.5693 6.87793Z",
    fill: "url(#paint12_linear_6264_73442)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6264_73442",
    x1: 12.2436,
    y1: 9.5918,
    x2: 12.2436,
    y2: 21.9989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6264_73442",
    x1: 21.9358,
    y1: 12.3047,
    x2: 21.9358,
    y2: 14.6336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6264_73442",
    x1: 2.55102,
    y1: 12.3037,
    x2: 2.55102,
    y2: 14.6305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6264_73442",
    x1: 20.7727,
    y1: 3.38574,
    x2: 20.7727,
    y2: 8.03933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6264_73442",
    x1: 3.32742,
    y1: 6.10059,
    x2: 3.32742,
    y2: 10.7542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6264_73442",
    x1: 7.97995,
    y1: 3,
    x2: 7.97995,
    y2: 4.16447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6264_73442",
    x1: 7.97995,
    y1: 4.9375,
    x2: 7.97995,
    y2: 6.10197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6264_73442",
    x1: 8.94845,
    y1: 4.16309,
    x2: 8.94845,
    y2: 4.9394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6264_73442",
    x1: 7.01095,
    y1: 4.16406,
    x2: 7.01095,
    y2: 4.94038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6264_73442",
    x1: 15.3442,
    y1: 5.71387,
    x2: 15.3442,
    y2: 6.87834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6264_73442",
    x1: 15.3462,
    y1: 7.65137,
    x2: 15.3462,
    y2: 8.81584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6264_73442",
    x1: 16.3156,
    y1: 6.87598,
    x2: 16.3156,
    y2: 7.65229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6264_73442",
    x1: 14.3752,
    y1: 6.87793,
    x2: 14.3752,
    y2: 7.65424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarWashColorIcon);
export default __webpack_public_path__ + "static/media/car-wash-color-icon.c8798dcd94f83e6bf5902bc8aab99d89.svg";
export { ForwardRef as ReactComponent };